// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","774":"component---src-pages-galerie-tsx"}[chunkId] || chunkId) + "-" + {"108":"5740adf1bbd34f9e19b1","245":"36565c8155d0b27bd5d2","452":"52d4f6bc7c050db0d3df","453":"033b503d058fb93be997","774":"838169c88dff8cee2351"}[chunkId] + ".js";
};